import { render, staticRenderFns } from "./Consultorio.vue?vue&type=template&id=a1eeef74"
import script from "./Consultorio.vue?vue&type=script&lang=ts"
export * from "./Consultorio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports